export * from './TechPhoneClassicIcon';
export * from './TechPhoneClassicIcon16Light';
export * from './TechPhoneClassicIcon16Regular';
export * from './TechPhoneClassicIcon16Solid';
export * from './TechPhoneClassicIcon20Light';
export * from './TechPhoneClassicIcon20Regular';
export * from './TechPhoneClassicIcon20Solid';
export * from './TechPhoneClassicIcon24Regular';
export * from './TechPhoneClassicIcon24Solid';
export * from './TechPhoneClassicIcon32Regular';
export * from './TechPhoneClassicIcon64Regular';
